const AV = require('./core');
const useLiveQuery = require('./use-live-query');

module.exports = useLiveQuery(AV);



// WEBPACK FOOTER //
// ./src/entry/core-live-query.js